<script>
import axios from '@/utils/axios';

export default {
inject: ['setLoading'],  
data() {
  return {
    errors: {},
    title: "Sales",
    text: "Sales",
    text1: "Proposals",
    proposal: [],
    admin: [],
    banks: [],
  };
},

computed: {

},

mounted() {
 const public_token = this.$route.params.public_token;
 this.proposalByToken(public_token);
},

methods: {

 async proposalByToken(public_token){
  this.errors = {};
  this.setLoading(true);
  try{
   const response = await axios.get(`proposals/${public_token}`);
   this.proposal = response.data.data;
   if(this.proposal?.admin_id){
    this.adminDetail(this.proposal.admin_id);
    this.adminBanks(this.proposal.admin_id);
   }
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 isExpired(){
  if(this.proposal?.valid_until){
   const validUntil = new Date(this.proposal.valid_until);
   // If date string is just a date, treat as end of day inclusive
   if(this.proposal.valid_until.length === 10){
    validUntil.setHours(23, 59, 59, 999);
   }
   const now = new Date();
   return ( now > validUntil && this.proposal.status !== 'Accepted' && this.proposal.status !== 'Rejected' );
  }
  return false;
 },

 async downloadPDF(id){
  try{
   const response = await axios.get(`/proposals/${id}/pdf`, {
    responseType: 'blob'
   });

   const file = new Blob([response.data], { type: 'application/pdf' });
   const fileURL = URL.createObjectURL(file);

   // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileURL;
    // Optional: use a filename based on proposal number, id, or timestamp
    link.download = `proposal_${id}.pdf`;
    document.body.appendChild(link);
    link.click();
    // Remove the link and revoke the object URL
    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL);
   }catch(error){
    this.$swalToast("Failed to download PDF", 'error');
    console.error(error);
   }
 },

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<template>

 <div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-end page-breadcrumb mb-3 mt-3">
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">

    <span class="badge bg-danger me-3" v-if="isExpired()">Expired</span>  
    <span class="badge bg-warning p-2 me-3">{{ proposal.status }}</span>  

    <a href="javascript:void(0);" class="btn btn-dark align-items-center me-3" @click="downloadPDF('proposals', proposal.id)">
    <i class="ti ti-download me-2"></i>Download</a>

   <div class="dropdown" v-if="!isExpired() && (proposal.status !== 'Accepted' && proposal.status !== 'Rejected')">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i class="ti ti-grip-vertical me-2"></i> Action</button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_action" @click="$refs.proposalModal.proposalAction(proposal?.id, 'Accepted')"> <i class="ti ti-check me-2"></i> Accept</a></li>
      <li><hr class="dropdown-divider"></li>
      <li><a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_action" @click="$refs.proposalModal.proposalAction(proposal?.id, 'Rejected')"> <i class="ti ti-x me-2"></i>Reject</a></li>
    </ul>
  </div>
   
 </div>

   </div>
 <!-- /Breadcrumb -->

  <div id="watermark">
   <img :src="admin.company?.watermark_url || admin.company?.logo_url" alt="Watermark">
  </div>

  <!-- Invoices -->
 <div style="width:210mm; min-height:297mm; margin:auto; padding:20px; box-sizing:border-box; border:1px solid #ccc;">

  <!-- Header -->
  <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
    <tr>
      <th colspan="2" style="font-size:20px; font-weight:600; text-align:center; background:#444; color:#fff; padding:10px; letter-spacing:1px;"> PROPOSAL</th>
    </tr>
    <tr>
      <td style="width:40%; padding:10px; border:1px solid #ddd; vertical-align:top;">
        <img :src="admin.company?.logo_url" :alt="admin.company?.company_name" style="width:180px; height:auto; margin-bottom:6px;"><br>
      </td>
      <td style="width:60%; padding:10px; border:1px solid #ddd; text-align:right; vertical-align:top; line-height:1.5;">
        <h2 style="margin:0; font-size:18px; color:#222;">{{ admin?.company?.company_name }}</h2>
        <p v-if="admin?.company?.gst" style="margin:2px 0;">GSTIN: <strong>{{ admin?.company?.gst }}</strong></p>
        <p style="margin:2px 0;">ISO 9001:2015 CERTIFIED COMPANY</p>
        <p style="margin:2px 0;">Email: <strong>{{ admin?.company?.email }}</strong></p>
        <p style="margin:2px 0;">{{ admin?.company?.address }} {{ admin?.company?.city }}, {{ admin?.company?.state }} {{ admin?.company?.country }} - {{ admin?.company?.pincode }}</p>
        <p v-if="admin?.company?.mobile" style="margin:2px 0;">Phone: <strong>{{ admin?.company?.mobile }}</strong></p>
      </td>
    </tr>
    <tr>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Name:</strong> {{ proposal.to_name }}</p>
        <p style="margin:2px 0;" v-if="proposal.to_email"><strong>Email:</strong> {{ proposal.to_email }}</p>
        <p style="margin:2px 0;" v-if="proposal.to_phone"><strong>Phone:</strong> {{ proposal.to_phone }}</p>
        <p style="margin:2px 0;" v-if="proposal.to_pincode"><strong>Address:</strong> {{ proposal.to_address }}, {{ proposal.to_city }}, {{ proposal.to_state }}, {{ proposal.to_country }} - {{ proposal.to_pincode }}</p>
        <p style="margin:2px 0;" v-if="proposal.gst_no"><strong>GSTIN:</strong> {{ proposal.gst_no }}</p>
      </td>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Proposal No:</strong> {{ proposal?.proposal_number }}</p>
        <p style="margin:2px 0;"><strong>Date:</strong> {{ $formatDate(proposal?.proposal_date, 'DD MMM YYYY') }}</p>
        <p style="margin:2px 0;"><strong>Sales Person:</strong> {{ proposal?.sales_person?.name }}</p>
        <p style="margin:2px 0;"><strong>Contact:</strong> {{ proposal?.sales_person?.mobile }}</p>
        <p style="margin:2px 0;"><strong>Email:</strong> {{ proposal?.sales_person?.email }}</p>
      </td>
    </tr>
    <tr>
      <td colspan="2" style="padding:10px; border:1px solid #ddd; text-align:left; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Subject:</strong> {{ proposal.subject }}</p>
        <div class="dynamic">
         <strong>Summary:</strong> 
         <div v-html="proposal.summary"></div>
        </div> 
      </td>
    </tr>
  </table>

  <!-- Product Table -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr style="background:#f2f2f2;">
      <th style="border:1px solid #ddd; padding:6px;">S.No.</th>
      <th style="border:1px solid #ddd; padding:6px;">Title</th>
      <th style="border:1px solid #ddd; padding:6px;">HSN / SAC</th>
      <th style="border:1px solid #ddd; padding:6px;">Price</th>
      <th style="border:1px solid #ddd; padding:6px;">Quantity</th>
      <th style="border:1px solid #ddd; padding:6px;">Unit</th>
      <th style="border:1px solid #ddd; padding:6px;" v-if="proposal.tax_mode === 'Item'">Tax</th>
      <th style="border:1px solid #ddd; padding:6px;">Sub Total</th>
      <th style="border:1px solid #ddd; padding:6px;">Final Amount</th>
    </tr>

    <tr v-for="(row, index) in proposal.proposal_items" :key="index">
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{index + 1}}</td>
      <td style="border:1px solid #ddd; padding:6px; line-height:1.4;">
       {{row.name}}
       <p v-if="row.description" style="margin-bottom:0;" v-html="row.description"></p>
      </td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{ row.hsn_code ?? 'N/A' }}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;">{{row.taxable_amount}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{row.quantity}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{row.unit}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;" v-if="proposal.tax_mode === 'Item'">{{row?.tax?.name}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;">{{row.taxable_amount * row.quantity}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right; font-weight:600;">{{row.total}}</td>
    </tr>
      
    <!-- Totals -->
    <tr>
      <td colspan="9" style="border:1px solid #ddd; text-align:right; padding:10px; font-size:14px; line-height:1.6;">
        Sub Total: <strong>{{ proposal.subtotal }}</strong><br>

        <!-- Tax Display Logic -->
        <template v-if="proposal.tax_mode === 'Invoice'">
          Tax: {{ proposal.tax.name }}: <strong>{{ proposal.tax_amount }}</strong><br>
        </template>
        
        <template v-else-if="proposal.tax_mode === 'Item' && proposal.tax_breakdown && Object.keys(proposal.tax_breakdown).length > 0">
          <!-- Show individual tax rates -->
          <template v-for="(taxData, taxRate) in proposal.tax_breakdown" :key="taxRate">
            {{ taxData.name }} Tax on {{ parseFloat(taxData.taxable_amount || 0).toFixed(2) }}: <strong>{{ parseFloat(taxData.tax_amount).toFixed(2) }}</strong><br>
          </template>
        </template>
        
        <template v-else-if="proposal.tax_mode === 'Item'">
          Item Taxes: <strong>{{ proposal.tax_amount }}</strong><br>
        </template>

        <span v-if="proposal.discount !== '0.00'">Discount: <strong>{{ proposal.discount }}</strong><br></span>
        
        <span style="font-size:15px; font-weight:600; color:#222;">Final Amount: {{ `${proposal?.lead?.currency.code} ${proposal.total}` }}</span><br>
        ({{ $amountInWords(proposal.total) }})
      </td>
    </tr>
  </table>

  <!-- Terms -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;" v-if="proposal.terms">
    <tr>
      <td style="border:1px solid #ddd; padding:10px;">
       <h5 style="margin-bottom: 1rem;">Terms:</h5>
       <div class="dynamic">
        <div v-html="proposal.terms"></div>
       </div> 
      </td>
    </tr>
  </table>

  <!-- Bank Details -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr>
      <th colspan="3" style="border:1px solid #ddd; padding:10px; text-align:left; background:#f2f2f2;">
        <u>BANK DETAILS</u>
      </th>
    </tr>
    <tr>

      <td style="border:1px solid #ddd; padding:10px; width:33%; vertical-align:top; line-height:1.6;" v-for="row in banks">
        <strong>{{row.name}}</strong><br>
        A/C Holder: {{row.account_holder_name}}<br>
        A/C No: {{row.account_no}}<br>
        IFSC: {{row.ifsc}}<br>
        Branch: {{row.branch}}<br>
        <img :src="row.image_url || $clientImage(row.image, 'banks', admin)" width="100" />
      </td>
    </tr>
  </table>

<div style="display:flex;justify-content: space-around;margin-top:25px;" class="dynamic">
<div style="width:70%">
 <h5 style="margin-bottom: 1rem;" v-if="proposal.notes">Notes:</h5> 
   <div v-html="proposal.notes"></div>
</div>
<div style="width:30%">  
  <!-- Signature -->
  <div style="text-align:right; line-height:1.6;">
    <img :src="admin.company?.signature_url" style="width:120px; height:auto; margin-bottom:5px;"><br>
    <strong style="font-size:15px;">Authorised Signatory</strong><br>
    <span>On behalf of {{admin.company?.company_name}}</span>
  </div>
</div>
</div>

</div>
  <!-- /Invoices -->

    <!-- <div class="d-flex justify-content-center align-items-center mb-4">
      <a href="javascript:void(0);" class="btn btn-primary d-flex justify-content-center align-items-center me-2"><i class="ti ti-printer me-2"></i>Print Invoice</a>
      <a href="javascript:void(0);" class="btn btn-white d-flex justify-content-center align-items-center border"><i class="ti ti-copy me-2"></i>Clone Invoice</a>
    </div> -->
  </div>

 <proposal-modal ref="proposalModal" @updated="proposalByToken(proposal?.public_token)"></proposal-modal>
</template>
